import React, {Component} from 'react';
import { connect } from 'react-redux';
import { firebaseConnect } from 'react-redux-firebase'
import { bindActionCreators, compose } from 'redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'
import classnames from 'classnames';
import SlideForm from './SlideForm/SlideForm';
import FormPreview from './FormPreview';
import * as folioActions from '../../actions/folio-actions';
import './form.scss';
import '../../styles.scss';
import Button from '../../components/Button/Button';
import Track from '../../components/Track/Track';
import { Formik, Field } from 'formik';
import Overview from "./Overview";
import Credits from "./Credits";
import Notification from '../../components/Notification/Notification';
import AdminTabs from '../../components/AdminTabs/AdminTabs';
import defaultFieldValues from './defaultFieldValues';

class AddContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      project: {},
      activeTab: 'overview',
      fieldValues: defaultFieldValues,
      id: 0
    }
  }

  componentDidMount() {
    const id = this.props.match.params.id || this.state.id;
    if (id && this.props.projects) {
      const project = this.props.projects[id];
      this.setState({project, fieldValues: project.name ? project : {}, id: id });
    }
  }

  componentDidUpdate(prevProps) {
    // Projects loaded from firebase.
    if (prevProps.projects !== this.props.projects && this.props.projects.name !== '') {
      const id = this.props.match.params.id || this.state.id;
      if (id) {
        const project = this.props.projects[id];
        this.setState({project, fieldValues: project.name ? project : {}, id: id });
      }
    }

    // Login
    if (this.props.auth.isLoaded && this.props.auth.isEmpty) { this.props.actions.redirectToLogin(); }
  }

  handleTabSelection = (selection) => this.setState( () => ({ activeTab: selection }));

  saveData = (data) => {
    if (this.validateForm((data))) {
      const { actions, firebase } = this.props;
      if (this.state.id !== 0) {
        firebase.ref('projects').child(this.state.id).set(data).then(() => {
          actions.showNotification('Project updated.');
          setTimeout(() => { actions.hideNotification(); }, 8000);
        });
      }
      else {
        firebase.ref('projects').push(data).then((response) => {
          this.setState({ id: response.ref.key });
          actions.showNotification('Project saved.');
          setTimeout(() => { actions.hideNotification(); }, 8000);
        });
      }
    } else {

    }

  };

  validateForm = (values) => {
    this.setState(() => ({ name: values.name }));
    let errors = {};
    if (!values.name || values.name === '') {
      errors.name = 'Title is required';
      this.props.actions.showNotification('Project must have a name.', true);
    } else if (!values.directory || values.directory === '') {
      errors.directory = 'Directory is required';
    }
    return errors; //errors;
  };

  render() {
    const classes = ['form-add-project', { ['show-sidebar']: this.state.drawerOpen }];
    return (
        <Track className="form-wrapper">
          <Notification message={ this.props.folio.notification }
                        isDismissable={ this.props.folio.notificationIsDismissable }
                        actions={ this.props.actions }/>
          <ul className="breadcrumbs">
            <li><Link to="/admin/projects">Admin</Link></li>
            <li>{`Editing ${this.state.project ? this.state.project.name : '' }`}</li>
          </ul>

          <Formik initialValues={ this.state.fieldValues }
                  enableReinitialize
                  validate={ (values) => this.validateForm(values) }
                  onSubmit={ (values, { setSubmitting }) => {
                    setTimeout(() => {
                      this.saveData(values);
                      setSubmitting(false);
                      }, 400);
                  } }
                  render={ ({values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
                      <div>
                        <form className={ classnames(classes) } onSubmit={ handleSubmit } ref={ref => { this.form = ref }}>
                          <Field component="input" name="id" value={ this.state.id } type="hidden" />
                          <Button className="button__publish" type="submit" disabled={isSubmitting}>Publish</Button>
                          <Button className="button__preview" onClick={ (e) => { e.preventDefault(); this.setState( (state) => ({ drawerOpen: !state.drawerOpen })) } }>Preview</Button>
                          <AdminTabs handleSelection={ this.handleTabSelection }
                                     activeTab={ this.state.activeTab }
                          />
                          <Overview activeTab={ this.state.activeTab }
                                    id={ this.state.id }
                                    values={ values }
                                    errors={ errors }
                                    firebase={ this.props.firebase }
                          />
                          <SlideForm active={ this.state.activeTab === 'slides' }
                                     values={ values }
                                     setFieldValue={ setFieldValue }
                                     name="slides"
                                     firebase={ this.props.firebase }
                                     { ...this.props }
                          />
                          <Credits activeTab={ this.state.activeTab }
                                   values={ values }
                                   setFieldValue={ setFieldValue }
                                   firebase={ this.props.firebase }
                          />
                        </form>
                        <FormPreview open={ this.state.drawerOpen } values={ values }/>
                      </div>) }
           />
        </Track>
    );
  }
}

AddContainer.propTypes = {
  folio: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  projects: PropTypes.object
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(folioActions, dispatch)
  }
}

export default compose(
    firebaseConnect(['/projects']),
    connect(
        (state) => ({
          folio: state.folio,
          projects: state.firebase.data.projects,
          auth: state.firebase.auth
        }), mapDispatchToProps
    )
)(AddContainer)



// WEBPACK FOOTER //
// ./src/containers/add/add.js